// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__xnwaw","label":"Radio_label__1L1VZ","checkMark":"Radio_checkMark__1hWX2","disabled":"Radio_disabled__1K5dI"};